import { put } from 'redux-saga/effects';
import { commentsModel } from '../index';
import { CommentsFlow } from '../types';

export function* setSelectedThreads({
  payload,
}: ReturnType<typeof commentsModel.actions.setSelectedThreads>) {
  yield put(commentsModel.actions.updateSelectedThreads(payload));
  yield put(
    commentsModel.actions.setCommentsFlow(
      payload.length > 0 ? CommentsFlow.Preview : null
    )
  );
}
